/* eslint-disable react/jsx-no-undef */
/* eslint-disable radix */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { Box, Typography, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import FilterListIcon from '@material-ui/icons/FilterList';
import TextField from '@material-ui/core/TextField';

import LoadingPageText from '../../../common/Loading/LoadingPageText';
import { DropdownFilter } from '../../../Planner/Filters/DropdownFilter';
import { useAutoAllocationLogs } from '../../../../actions/areas/planner/fetchHooks';
import { parseDateToLongTime } from '../../../../utils/dates';
import _ from '../../../../utils/lodash';

const logTypeEnums = [{ name: 'Successfully allocated', id: 1 }, { name: 'Failed attempt', id: 2 }];

export default function AutoAllocationLogs({ events, selectedGroup }) {
  const groupId = selectedGroup[0];
  const [state, setState] = useState({
    searchTerm: '',
    logType: '',
  });
  const { data, isDataLoading } = useAutoAllocationLogs({ groupId }, false);

  if (isDataLoading)
    return <LoadingPageText showHeader={false}>Wait a moment while we gather AutoAllocation info...</LoadingPageText>;

  const headerRender = () => {
    return (
      <div className="sidePanel-header form-header">
        <div className="sidePanel-header-subtitle">
          <Box display="flex">
            <Box flexGrow={1} py={1}>
              <Typography variant="subtitle1">
                Logs for {selectedGroup[1]} {selectedGroup[2] !== '-' && `(duration ${selectedGroup[2]})`}
              </Typography>
            </Box>
            <Box>
              <IconButton onClick={events.onClose}>
                <CancelIcon />
              </IconButton>
            </Box>
          </Box>
        </div>
      </div>
    );
  };

  const formatMessage = log => (
    <Box display="flex" flexWrap="nowrap" p={0} justifyContent="flex-start" px={1}>
      <Box p={1} textAlign="end" className="log-timestamp">
        {`${parseDateToLongTime(log.createdDate)}  ->`}
      </Box>
      <Box p={1} flexGrow={1} className="log-message">
        <div dangerouslySetInnerHTML={{ __html: log.message }} />
      </Box>
    </Box>
  );

  const filterData = () => {
    if (state.logType === '' && state.searchTerm === '') return data;
    const filteredData = _.filter(data, x => {
      let filterByText = true;

      let filterByLogType = true;
      if (state.logType !== '') {
        filterByLogType = (state.logType === 1) === x.isSuccessful;
      }

      if (state.searchTerm !== '' && state.searchTerm.length >= 3) {
        filterByText = _.includes(x.message.toLowerCase(), state.searchTerm.toLowerCase());
      }
      return filterByLogType && filterByText;
    });
    return filteredData;
  };

  const contentRender = () => {
    const filteredData = filterData();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    const logContentHeight = windowHeight - 90;
    const listStyle = { height: `${logContentHeight}px`, overflow: 'auto' };

    return (
      <ul id="aa-content-wrapper" style={listStyle}>
        {filteredData.map(x => (
          <li className={x.isSuccessful ? 'success' : 'error'}>{formatMessage(x)}</li>
        ))}
      </ul>
    );
  };

  const filterRender = () => {
    return (
      <section className="slick-page-header-section">
        <Box className="filter-section" display="flex" flexWrap="nowrap" p={0} justifyContent="flex-start" px={1}>
          <Box p={1}>
            <FilterListIcon />
          </Box>
          <Box p={1} width={300} flexGrow={1}>
            <TextField
              id="nameTextField"
              required
              defaultValue={state.searchTerm}
              onChange={e => setState({ ...state, searchTerm: e.target.value })}
              placeholder="Search logs"
              style={{ width: '100%' }}
            />
          </Box>
          <Box p={1} width={70} textAlign="end">
            <span>Log type</span>
          </Box>
          <Box p={1} width={100} flexGrow={1}>
            <DropdownFilter
              data={logTypeEnums}
              filterKey={'logType'}
              hasAny
              filterValue={state.logType}
              defaultValue={['']}
              onChange={(name, value) => setState({ ...state, logType: value })}
            />
          </Box>
          <Box p={1} flexGrow={1} textAlign="end" />
        </Box>
      </section>
    );
  };

  const handleScrolls = () => {};

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer
        anchor="right"
        open
        onOpen={() => {}}
        onClose={events.onClose}
        ModalProps={{
          onBackdropClick: events.onClose,
        }}
      >
        {headerRender()}
        {filterRender()}
        {contentRender()}
        {handleScrolls()}
      </SwipeableDrawer>
    </section>
  );
}
